.container {
  max-width: 400px;
  margin: var(--space-xxxl) auto;
  text-align: center;
}

.content {
  margin-bottom: var(--space-m);
}
